// Presentation helpers for the ember end-of-run scorecard (see run_summary.ts). Split out so they
// can be unit-tested without pulling in the panel's pixi/paperdoll dependencies.

// How a creature kind from the server is presented. Keys are what ember-controller.js reports: a
// wave enemy's orchestrator role, a wilderness enemy's race, or "rabbit". Anything unknown still
// renders (title-cased, with the generic skull) so a new creature type needs no client change.
const CREATURE_META: Record<string, { label: string; emoji: string }> = {
    skirmisher: { label: "Skirmishers", emoji: "💀" },
    raider: { label: "Raiders", emoji: "🗡️" },
    archer: { label: "Archers", emoji: "🏹" },
    bruiser: { label: "Bruisers", emoji: "🧟" },
    eliteRaider: { label: "Elite raiders", emoji: "👹" },
    slime: { label: "Slimes", emoji: "🟢" },
    snake: { label: "Snakes", emoji: "🐍" },
    redspider: { label: "Spiders", emoji: "🕷️" },
    rabbit: { label: "Rabbits", emoji: "🐇" },
}

export const creatureMeta = (key: string): { label: string; emoji: string } =>
    CREATURE_META[key] || { label: key.charAt(0).toUpperCase() + key.slice(1), emoji: "💀" }

// m:ss, or h:mm:ss for the rare long run.
export const formatDuration = (ms: number): string => {
    const total = Math.max(0, Math.round(ms / 1000))
    const hours = Math.floor(total / 3600)
    const minutes = Math.floor((total % 3600) / 60)
    const seconds = total % 60
    const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`)
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`
}
